import { onApplicationMenu, onTopLevelRoutes } from 'core';
import Router from './components/Router';

onTopLevelRoutes(() => ({
  path: '/lending',
  secure: true,
  component: Router,
}));

onApplicationMenu(() => ({
  group: 'business',
  label: 'lendings',
  icon: 'exchange',
  to: '/lending',
}));
